export const getWALink = (link: string, preFilledMessage?: string): string =>
    link ? `${link}${preFilledMessage ? `?text=${preFilledMessage}` : ""}` : "";
